<template>
  <div>
    <ServerEdit ref="ServerEdit" v-on:editComplete="getServerData(server.page)"></ServerEdit>
    <Card shadow>
      <div>
        <Row>
          <AllTenantSwitch ref="AllTenantSwitch" v-on:callback="getServerData()" style="float: left;"></AllTenantSwitch>
          <Col style="float: left;">
            <Form ref="searchForm" inline @submit.native.prevent :model="searchForm" :label-width="60">
              <FormItem label="实例名称">
                <Input v-model="searchForm.name" style="min-width: 150px;" />
              </FormItem>
              <FormItem :label-width="0" class="mob-align-right">
                <Button type="primary" @click="getServerData()">搜索</Button>
                <Button @click="searchFormReset" style="margin-left: 10px">重置</Button>
              </FormItem>
            </Form>
          </Col>
          <Col style="float: right;">
            <div style="float: right;" class="align-right">
              <Button :style="{marginRight: '8px', marginBottom: '10px'}" icon="md-refresh" @click="getServerData(server.page)">刷新</Button>
              <Button
                @click="$router.push({name: 'private_cloud_fast_create_server'})"
                type="primary"
                icon="md-cloud-upload"
                :style="{marginRight: '8px', marginBottom: '10px'}">快速创建实例</Button>
              <!--<Button-->
                <!--@click="$router.push({name: 'private_cloud_create_server'})"-->
                <!--type="primary"-->
                <!--icon="md-cloud-upload"-->
                <!--:style="{marginBottom: '10px'}">创建实例</Button>-->
            </div>
          </Col>
        </Row>
        <Table
          :loading="tableLoading"
          ref="table"
          :data="server.data"
          :columns="server.columns">
          <template slot="ActionMenu" slot-scope="props">
            <ActionMenu
              :status="props.detail.status"
              :server_id="props.row.id"
              :server_name="props.row.name" v-on:callback="getServerData(server.page)"></ActionMenu>
          </template>
        </Table>
        <div style="margin: 10px 0; overflow: hidden;">
          <div style="float: left;">
            当前显示 {{ server.data.length }} 条记录，总共 {{ server.count }} 条记录
          </div>
          <div style="float: right;">
            <page
              :total="server.count"
              :current="server.page"
              :page-size="server.size"
              @on-change="getServerData"></page>
          </div>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudServer } from '@/api/private-cloud/server'
import { statusTransfer } from './components/server_status_transfer'
import { resourceIdTransObject, resourceIdTransName } from '@/view/private-cloud/cacheData'
import AllTenantSwitch from '@/view/private-cloud/components/allTenantSwitch'
import moment from 'moment'
import ActionMenu from './components/ActionMenu'
import ServerEdit from './components/server-edit'
import Logs from './../Logs'

export default {
  name: 'server',
  components: {
    moment,
    ActionMenu,
    ServerEdit,
    AllTenantSwitch,
    Logs
  },
  data () {
    return {
      tableLoading: false,
      server: {
        data: [],
        columns: [
          {
            type: 'selection',
            minWidth: 60,
            align: 'center'
          },
          {
            title: '区域',
            minWidth: 80,
            align: 'center',
            tooltip: true,
            key: 'OS-EXT-AZ:availability_zone'
            // render: (h, params) => {
            //   let result = ''
            //   let detailInfo = params.row.detail_info
            //   if (detailInfo) {
            //     result = detailInfo['OS-EXT-AZ:availability_zone']
            //   }
            //   return h('span', result)
            // }
          },
          {
            title: '租户',
            minWidth: 130,
            align: 'center',
            key: 'tenant_id',
            render: (h, params) => {
              return h('span', resourceIdTransName('projects', params.row.tenant_id))
            }
          },
          {
            title: '实例名称',
            align: 'center',
            minWidth: 120,
            tooltip: true,
            key: 'name',
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.$router.push({ name: 'private_cloud_server_detail', params: { id: params.row.id } })
                  }
                }
              }, params.row.name)
            }
          },
          {
            title: 'IP地址',
            minWidth: 200,
            tooltip: true,
            align: 'center',
            render: (h, params) => {
              let result = []
              let addresses = params.row.addresses
              for (let i in addresses) {
                for (let v in addresses[i]) {
                  if (addresses[i][v]['OS-EXT-IPS:type'] === 'floating') {
                    result.push(h('p', '浮动IP：' + addresses[i][v].addr))
                  } else {
                    result.push(h('p', '固定IP：' + addresses[i][v].addr))
                  }
                }
              }
              return h('div', result)
            }
          },
          {
            title: '规格',
            align: 'center',
            minWidth: 180,
            tooltip: true,
            key: 'flavor_name',
            render: (h, params) => {
              if (params.row.flavor) {
                const resourceObject = resourceIdTransObject('flavors', params.row.flavor.id)
                if (resourceObject) {
                  let tooltipContent = [
                    h('p', `${resourceObject.name}`),
                    h('p', `内核：${resourceObject.vcpus}`),
                    h('p', `内存：${Math.floor(resourceObject.ram / 1024)}G`),
                    h('p', `磁盘：${resourceObject.disk}GB`)
                  ]
                  return h('Tooltip', [
                    h('span',
                      `${resourceObject.name} | ${resourceObject.vcpus}核 | ${Math.floor(resourceObject.ram / 1024)}G | ${resourceObject.disk}GB`
                    ),
                    h('div', {
                      slot: 'content'
                    }, tooltipContent)
                  ])
                } else {
                  return h('span', params.row.flavor.id)
                }
              }
            }
          },
          {
            title: '密钥对',
            minWidth: 100,
            align: 'center',
            tooltip: true,
            key: 'key_name',
            render: (h, params) => {
              return h('span', params.row.key_name ? params.row.key_name : '无')
            }
          },
          {
            title: '状态',
            minWidth: 160,
            align: 'center',
            render: (h, params) => {
              return h('Badge', {
                props: {
                  text: statusTransfer(params.row.status).status,
                  status: statusTransfer(params.row.status).color
                }
              })
            }
          },
          {
            title: '任务',
            minWidth: 120,
            align: 'center',
            key: 'OS-EXT-STS:task_state',
            render: (h, params) => {
              if (params.row['OS-EXT-STS:task_state']) {
                return h('Badge', {
                  props: {
                    text: params.row['OS-EXT-STS:task_state'],
                    status: 'processing'
                  }
                })
              } else {
                return h('span', '无')
              }
            }
          },
          {
            title: '电源状态',
            minWidth: 130,
            align: 'center',
            render: (h, params) => {
              let status = params.row['OS-EXT-STS:power_state']
              let color = status === 0 ? 'warning'
                : status === 1 ? 'success'
                  : status === 3 ? 'warning'
                    : status === 4 ? 'error'
                      : status === 6 ? 'error'
                        : status === 7 ? 'warning'
                          : 'warning'
              let text = status === 0 ? '无状态'
                : status === 1 ? '运行中'
                  : status === 3 ? '已暂停'
                    : status === 4 ? '关闭'
                      : status === 6 ? '崩溃'
                        : status === 7 ? '挂起'
                          : status
              return h('Badge', {
                props: {
                  text: text,
                  status: color
                }
              })
            }
          },
          {
            title: '创建时间',
            minWidth: 190,
            align: 'center',
            render: (h, params) => {
              return h('span', params.row.created ? moment(params.row.created).format('YYYY-MM-DD HH:mm:ss') : '')
            }
          },
          {
            title: '操作',
            minWidth: 170,
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.$router.push({ name: 'private_cloud_server_detail', params: { id: params.row.id } })
                    }
                  }
                }, '详情'),
                this.$refs.table.$scopedSlots.ActionMenu({
                  row: params.row,
                  detail: params.row,
                  idx: params.row._index
                })
              ])
            }
          }
        ],
        count: 0,
        page: 1,
        size: 10
      },
      statusList: [
        {value: 'ACTIVE', label: '运行'},
        {value: 'SHELVED', label: '搁置'},
        {value: 'SHUTOFF', label: '关机'}
      ],
      searchForm: {
        name: '',
        image: '',
        ip: '',
        status: ''
      },
      timer: null
    }
  },
  mounted: function () {
    this.setTimer()
    this.init()
  },
  beforeDestroy () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    // 初始化
    init () {
      this.getServerData()
    },
    // 获取实例数据
    getServerData (value = 1, loading = true) {
      this.searchForm.page = value
      this.server.page = value
      this.searchForm.size = this.server.size
      this.searchForm.all_tenants = this.$refs.AllTenantSwitch.allTenants()
      this.tableLoading = loading
      let reqData = JSON.parse(JSON.stringify(this.searchForm))
      this.setTimer()
      getPrivateCloudServer(reqData).then(res => {
        if (reqData.page !== this.searchForm.page) {
          return
        }
        this.server.data = res.data.results
        this.server.count = res.data.count
        this.tableLoading = false
        // if (loading) {
        //   for (let i in this.server.data) {
        //     if (this.server.data[i]['OS-EXT-STS:task_state']) {
        //       this.setTimer()
        //       break
        //     }
        //   }
        // } else {
        //   let haveTask = false
        //   for (let i in this.server.data) {
        //     if (this.server.data[i]['OS-EXT-STS:task_state']) {
        //       haveTask = true
        //       break
        //     }
        //   }
        //   if (!haveTask) {
        //     clearInterval(this.timer)
        //     this.timer = null
        //   }
        // }
      }).catch(res => {
        this.tableLoading = false
        if (res.request) {
          this.$Notice.error({
            title: '获取实例列表失败！',
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取实例列表失败！'
          })
        }
      })
    },
    // 重置搜索表单
    searchFormReset () {
      this.searchForm = {
        name: '',
        image: '',
        ip: '',
        status: ''
      }
    },
    // 自动刷新列表
    setTimer () {
      clearInterval(this.timer)
      this.timer = null
      if (this.timer == null) {
        this.timer = setInterval(() => {
          this.getServerData(this.server.page, false)
        }, 10000)
      }
    }
  }
}
</script>

<style>
  .btn-group .dropdown-menu {
    position: relative !important;
  }
</style>
